import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  results: [],
  filters: {},
  selectedFilter: {},
  isFetching: false,
  totalCount: 0,
  totalPage: 0,
  pageNo: 1,
  pageSize: 12,
  suggestions: [],
  searchTerm: null,
  selectedColor: []
});

// Getters
const getters = {
  results: state => {
    return state.results;
  },
  filters: state => {
    return state.filters;
  },
  selectedFilter: state => {
    return state.selectedFilter;
  },
  isFetching: state => {
    return state.isFetching;
  },
  totalCount: state => {
    return state.totalCount;
  },
  totalPage: state => {
    return state.totalPage;
  },
  pageNumber: state => {
    return state.pageNo;
  },
  showLoadMore: state => {
    return (
      state.totalPage > state.pageNo ||
      (state.isFetching && state.results.length === 0)
    );
  },
  suggestions: state => {
    return state.suggestions;
  },
  selectedColor: state => {
    return state.selectedColor;
  },
  getSearchTerm: state => {
    return state.searchTerm;
  }
};

// Mutations
const mutations = {
  setResults(state, { result }) {
    if (state.pageNo > 1) {
      state.results = [...state.results, ...result];
    } else {
      state.results = [...result];
    }
  },
  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setTotalCount(state, count) {
    state.totalCount = count;
  },
  setPagination(state, count) {
    state.totalPage = Math.ceil(count / state.pageSize);
  },
  setPageNo(state, pageNo) {
    state.pageNo = pageNo;
  },
  setSuggestions(state, result) {
    state.suggestions = result;
  },
  setSearchTerm(state, value) {
    state.searchTerm = value;
  },
  setSelectedColor(state, value) {
    state.selectedColor = value;
  }
};

// Actions
const actions = {
  getBenjaminMooreProducts({ commit, dispatch, state }, value) {
    dispatch("setIsFetching", true);
    let data = {
      pageSize: state.pageSize,
      page: state.pageNo,
      searchTerm: "",
      color: []
    };
    if(value)
    {
      data.page = 1;
      commit("setPageNo", 1);
    }
    if ((value && value.searchTerm) || state.searchTerm && state.searchTerm != '') {
      if((state.searchTerm == '' && value.searchTerm == null) || value && value.searchTerm == '')
      {
        commit("setSearchTerm", "");
      }
      else{
        data.searchTerm = value && value.searchTerm || state.searchTerm;
        commit("setSearchTerm", data.searchTerm);
      }
    }
    else{
      commit("setSearchTerm", "");
    }
    if ((value && value.color) || state.selectedColor.length > 0) {
      let color = state.selectedColor;
      if (value && value.color) {
        if(!state.selectedColor.includes(value.color))
        {
          if(Array.isArray(value.color))
          {
            color = [...state.selectedColor, ...value.color];
          }
          else{
            color = [...state.selectedColor, value.color];
          }
        }
        else{
          dispatch("removeColorFilter", value.color);
        }
      }
      
      commit("setSelectedColor", color);
      data.color = color;
    }
    PatcraftApi.getBenjaminMoore(data)
    .then(res => {
      if(res.data != '')
      {
        let result = res.data.Product;
        let totalCount = res.data.TotalCount;
        commit("setResults", { result });
        commit("setTotalCount", totalCount);
        commit("setPagination", totalCount);
        dispatch("setIsFetching", false);
      }
      else
      {
        let result = [];
        commit("setResults", { result });
        commit("setTotalCount", 0);
        commit("setPagination", 0);
        dispatch("setIsFetching", false);
      }
    })
    .catch(error => {
      let result = [];
      commit("setResults", { result });
      commit("setTotalCount", 0);
      commit("setPagination", 0);
      dispatch("setIsFetching", false);
    });
    
    let queryParams = "";
    if (state.searchTerm) queryParams = `&searchTerm=${state.searchTerm}`;

    let colors = "";
    state.selectedColor.forEach(element => {
      colors = colors + `${element},`;
    });
    if(colors != "")
    {
      colors = `&colors=` + colors.substring(0, colors.length-1);
    }
    queryParams = queryParams + colors;
    
    if(queryParams != "") 
    {
      history.pushState(
        {},
        null,
        window.location.href.split('?')[0] + `?` + queryParams.substring(1)
      )
    }
    else
    {
      history.pushState({}, null, window.location.href.split('?')[0]);
    }
  },
  setIsFetching({ commit }, value) {
    commit("setIsFetching", { value });
  },
  setPageNumber({ commit, dispatch }, pageNo) {
    commit("setPageNo", pageNo);
    dispatch("getBenjaminMooreProducts");
  },
  getSuggestions({ commit }, value) {
    commit("setSearchTerm", value);
    PatcraftApi.getBenjaminMooreSuggestions(value)
      .then(res => {
        let result = res.data;
        commit("setSuggestions", result);
      })
      .catch(error => {});
  },
  removeColorFilter({ commit, dispatch, state }, value) {
    const index = state.selectedColor.indexOf(value);
    state.selectedColor.splice(index, 1);
    commit("setSelectedColor", state.selectedColor);
    dispatch("getBenjaminMooreProducts");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
